import React from "react";

const BookingLoadingIcon = () => {
  return (
    <svg
      className="loading-indicator"
      width="373"
      height="372"
      viewBox="0 0 373 372"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <circle
          cx="186.979"
          cy="50.4708"
          r="13.6097"
          fill="url(#paint0_linear_1977_2779)"
        />
        <circle
          cx="142.771"
          cy="21.009"
          r="17.1526"
          transform="rotate(-15 142.771 21.009)"
          fill="url(#paint1_linear_1977_2779)"
        />
        <circle
          cx="90.6443"
          cy="89.6666"
          r="13.6807"
          transform="rotate(-45 90.6443 89.6666)"
          fill="url(#paint2_linear_1977_2779)"
        />
        <circle
          cx="38.2797"
          cy="100.149"
          r="17.2421"
          transform="rotate(-60 38.2797 100.149)"
          fill="url(#paint3_linear_1977_2779)"
        />
        <circle
          cx="322.508"
          cy="186.001"
          r="13.6097"
          transform="rotate(90 322.508 186.001)"
          fill="url(#paint4_linear_1977_2779)"
        />
        <circle
          cx="351.971"
          cy="141.791"
          r="17.1526"
          transform="rotate(75 351.971 141.791)"
          fill="url(#paint5_linear_1977_2779)"
        />
        <circle
          cx="283.314"
          cy="89.6666"
          r="13.6807"
          transform="rotate(45 283.314 89.6666)"
          fill="url(#paint6_linear_1977_2779)"
        />
        <circle
          cx="272.833"
          cy="37.301"
          r="17.2421"
          transform="rotate(30 272.833 37.301)"
          fill="url(#paint7_linear_1977_2779)"
        />
        <circle
          cx="186.979"
          cy="321.53"
          r="13.6097"
          fill="url(#paint8_linear_1977_2779)"
        />
        <circle
          cx="231.189"
          cy="350.992"
          r="17.1526"
          transform="rotate(-15 231.189 350.992)"
          fill="url(#paint9_linear_1977_2779)"
        />
        <circle
          cx="283.312"
          cy="282.334"
          r="13.6807"
          transform="rotate(-45 283.312 282.334)"
          fill="url(#paint10_linear_1977_2779)"
        />
        <circle
          cx="335.678"
          cy="271.852"
          r="17.2421"
          transform="rotate(-60 335.678 271.852)"
          fill="url(#paint11_linear_1977_2779)"
        />
        <circle
          cx="51.4489"
          cy="186.001"
          r="13.6097"
          transform="rotate(90 51.4489 186.001)"
          fill="url(#paint12_linear_1977_2779)"
        />
        <circle
          cx="21.9865"
          cy="230.21"
          r="17.1526"
          transform="rotate(75 21.9865 230.21)"
          fill="url(#paint13_linear_1977_2779)"
        />
        <circle
          cx="90.6426"
          cy="282.334"
          r="13.6807"
          transform="rotate(45 90.6426 282.334)"
          fill="url(#paint14_linear_1977_2779)"
        />
        <circle
          cx="101.126"
          cy="334.7"
          r="17.2421"
          transform="rotate(30 101.126 334.7)"
          fill="url(#paint15_linear_1977_2779)"
        />
        <circle
          cx="134.136"
          cy="94.474"
          r="10.6127"
          transform="rotate(-30 134.136 94.474)"
          fill="url(#paint16_linear_1977_2779)"
        />
        <circle
          cx="84.3626"
          cy="158.504"
          r="10.6681"
          transform="rotate(-75 84.3626 158.504)"
          fill="url(#paint17_linear_1977_2779)"
        />
        <circle
          cx="278.504"
          cy="133.158"
          r="10.6127"
          transform="rotate(60 278.504 133.158)"
          fill="url(#paint18_linear_1977_2779)"
        />
        <circle
          cx="214.475"
          cy="83.3831"
          r="10.6681"
          transform="rotate(15 214.475 83.3831)"
          fill="url(#paint19_linear_1977_2779)"
        />
        <circle
          cx="239.822"
          cy="277.526"
          r="10.6127"
          transform="rotate(-30 239.822 277.526)"
          fill="url(#paint20_linear_1977_2779)"
        />
        <circle
          cx="289.595"
          cy="213.496"
          r="10.6681"
          transform="rotate(-75 289.595 213.496)"
          fill="url(#paint21_linear_1977_2779)"
        />
        <circle
          cx="95.4514"
          cy="238.843"
          r="10.6127"
          transform="rotate(60 95.4514 238.843)"
          fill="url(#paint22_linear_1977_2779)"
        />
        <circle
          cx="159.481"
          cy="288.618"
          r="10.6681"
          transform="rotate(15 159.481 288.618)"
          fill="url(#paint23_linear_1977_2779)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1977_2779"
          x1="173.381"
          y1="50.5588"
          x2="200.592"
          y2="50.5588"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1977_2779"
          x1="125.633"
          y1="21.1199"
          x2="159.928"
          y2="21.1199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1977_2779"
          x1="76.9751"
          y1="89.7551"
          x2="104.328"
          y2="89.7551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1977_2779"
          x1="21.0521"
          y1="100.261"
          x2="55.5257"
          y2="100.261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1977_2779"
          x1="308.909"
          y1="186.089"
          x2="336.12"
          y2="186.089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1977_2779"
          x1="334.833"
          y1="141.902"
          x2="369.127"
          y2="141.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1977_2779"
          x1="269.645"
          y1="89.7551"
          x2="296.998"
          y2="89.7551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1977_2779"
          x1="255.605"
          y1="37.4125"
          x2="290.079"
          y2="37.4125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1977_2779"
          x1="173.381"
          y1="321.618"
          x2="200.592"
          y2="321.618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1977_2779"
          x1="214.051"
          y1="351.103"
          x2="248.346"
          y2="351.103"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1977_2779"
          x1="269.643"
          y1="282.423"
          x2="296.996"
          y2="282.423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1977_2779"
          x1="318.451"
          y1="271.963"
          x2="352.924"
          y2="271.963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1977_2779"
          x1="37.8507"
          y1="186.089"
          x2="65.0616"
          y2="186.089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1977_2779"
          x1="4.84826"
          y1="230.321"
          x2="39.1429"
          y2="230.321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1977_2779"
          x1="76.9734"
          y1="282.423"
          x2="104.326"
          y2="282.423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1977_2779"
          x1="83.8979"
          y1="334.811"
          x2="118.371"
          y2="334.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1977_2779"
          x1="123.532"
          y1="94.5426"
          x2="144.751"
          y2="94.5426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1977_2779"
          x1="73.7035"
          y1="158.573"
          x2="95.0331"
          y2="158.573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1977_2779"
          x1="267.9"
          y1="133.226"
          x2="289.119"
          y2="133.226"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1977_2779"
          x1="203.816"
          y1="83.4521"
          x2="225.146"
          y2="83.4521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1977_2779"
          x1="229.218"
          y1="277.595"
          x2="250.437"
          y2="277.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1977_2779"
          x1="278.936"
          y1="213.565"
          x2="300.265"
          y2="213.565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1977_2779"
          x1="84.8476"
          y1="238.912"
          x2="106.067"
          y2="238.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_1977_2779"
          x1="148.822"
          y1="288.687"
          x2="170.151"
          y2="288.687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BookingLoadingIcon;
